class StaticGifConverter {
  constructor() {
    this.init()
    // console.log("StaticGifConverter initialized")
  }

  init() {
    // console.log("StaticGifConverter.init()")
    const images = document.querySelectorAll('img[src$=".gif"]')
    images.forEach((image) => {
      this.replaceGifWithFirstFrame(image)
    })
  }

  replaceGifWithFirstFrame(imgElement) {
    // console.log("StaticGifConverter.replaceGifWithFirstFrame()")
    const offscreenImage = new Image()
    const canvas = document.createElement("canvas")
    const context = canvas.getContext("2d")

    offscreenImage.onload = () => {
      canvas.width = offscreenImage.width
      canvas.height = offscreenImage.height
      context.drawImage(offscreenImage, 0, 0)

      const firstFrameDataUrl = canvas.toDataURL("image/png")
      imgElement.src = firstFrameDataUrl

      // Clean up: Remove the offscreen image from memory
      offscreenImage.src = ""
    }

    // Set crossOrigin to anonymous for cross-origin images to avoid tainted canvas
    offscreenImage.crossOrigin = "anonymous"
    offscreenImage.src = imgElement.src
  }
}

export { StaticGifConverter }
